// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1TK7K","icon":"SortAdornment_icon__N1CaW","up":"SortAdornment_up__327qy","down":"SortAdornment_down__2ayNb","active":"SortAdornment_active__3gekv"};